/**
 * 视频单元格组件
 * 显示视频首帧图作为预览，点击在Modal中播放视频
 * 支持多个视频 URL，只显示第一个视频
 */
import React, { useState, useRef, useEffect } from 'react';
import { Modal } from 'antd';
import { PlayCircleOutlined } from '@ant-design/icons';

const VideoCell = ({ urls }) => {
  // 兼容单个 URL 和数组
  const urlList = Array.isArray(urls) ? urls : (urls ? [urls] : []);

  // 只处理第一个视频
  const url = urlList.length > 0 ? urlList[0] : null;

  const [visible, setVisible] = useState(false);
  const [thumbnail, setThumbnail] = useState(null);
  const [loading, setLoading] = useState(true);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!url || url === 'None' || url === 'null') {
      setLoading(false);
      return;
    }

    // 创建隐藏的video元素来获取首帧
    const video = document.createElement('video');
    video.crossOrigin = 'anonymous';
    video.preload = 'metadata';
    video.muted = true;
    
    video.onloadedmetadata = () => {
      // 视频元数据加载完成，跳转到第一帧
      video.currentTime = 0.1; // 跳转到0.1秒，确保有画面
    };

    video.onseeked = () => {
      // 跳转完成，绘制首帧到canvas
      try {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth || 320;
        canvas.height = video.videoHeight || 240;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        
        // 转换为base64图片
        const thumbnailUrl = canvas.toDataURL('image/jpeg', 0.8);
        setThumbnail(thumbnailUrl);
        setLoading(false);
      } catch (error) {
        console.error('生成视频缩略图失败:', error);
        setLoading(false);
      }
    };

    video.onerror = () => {
      console.error('视频加载失败:', url);
      setLoading(false);
    };

    video.src = url;
    videoRef.current = video;

    return () => {
      // 清理
      if (videoRef.current) {
        videoRef.current.src = '';
        videoRef.current = null;
      }
    };
  }, [url]);

  if (!url) {
    return <span style={{ color: '#999' }}>-</span>;
  }

  const handleClick = () => {
    setVisible(true);
  };

  return (
    <>
      <div
        className="video-cell-preview"
        style={{
          position: 'relative',
          width: '280px',
          height: '180px',
          cursor: 'pointer',
          borderRadius: '4px',
          overflow: 'hidden',
          backgroundColor: '#f0f0f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        onClick={handleClick}
      >
        {loading ? (
          <span style={{ fontSize: 12, color: '#999' }}>加载中...</span>
        ) : thumbnail ? (
          <>
            <img
              src={thumbnail}
              alt="视频预览"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                background: 'rgba(0, 0, 0, 0.6)',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff'
              }}
            >
              <PlayCircleOutlined style={{ fontSize: 20 }} />
            </div>
          </>
        ) : (
          <PlayCircleOutlined style={{ fontSize: 24, color: '#999' }} />
        )}
      </div>
      
      <Modal
        title="视频播放"
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        width={800}
        destroyOnClose
      >
        <video
          ref={canvasRef}
          controls
          autoPlay
          style={{ width: '100%', maxHeight: '70vh' }}
          src={url}
          onError={(e) => {
            console.error('视频播放失败:', url);
          }}
        >
          您的浏览器不支持视频播放。
        </video>
      </Modal>
    </>
  );
};

export default VideoCell;

